import React from 'react';
import LazyLoadObserver from 'components/LazyLoadObserver';
import { isBotNavigation } from 'utils';
import PropTypes from 'prop-types';

const LazyLoadComponent = (props) => {
    if(isBotNavigation()) return <>{props.children}</>;

    return <LazyLoadObserver {...props} isComponent={true}/>
}

LazyLoadComponent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    className: PropTypes.string
}

export default LazyLoadComponent;